export interface ProcessoCadastro {
  NCODIGO: number;
  NCODIGOWORKFLOW: number;
  CCODIGOUSUARIOPROTHEUS: string;
  CEMPRESA: string;
  CFILIAL: string;
  CSTATUS: string;
  CTIPO: string;
  CURGENTE: string;
  CCHAVE: string;
  DDATAINCLUSAO: Date | undefined;
  DDATAINICIO: Date | undefined;
  DDATAAPROVACAOCOMPRAS: Date | undefined;
  DDATAAPROVACAOCONTABIL: Date | undefined;
  DDATAFINALIZACAO: Date | undefined;
}

export const defaultProcessoCadastro = (): ProcessoCadastro => {
  return {
    NCODIGO: 0,
    NCODIGOWORKFLOW: 0,
    CCODIGOUSUARIOPROTHEUS: '',
    CEMPRESA: '',
    CFILIAL: '',
    CSTATUS: '',
    CTIPO: '',
    CURGENTE: 'N',
    CCHAVE: '',
    DDATAINCLUSAO: undefined,
    DDATAINICIO: undefined,
    DDATAAPROVACAOCOMPRAS: undefined,
    DDATAAPROVACAOCONTABIL: undefined,
    DDATAFINALIZACAO: undefined,
  };
};
